(function(angular) {
    'use strict';

    angular.module('aprima-core').provider('DeviceSettings', [
        DeviceSettingsProvider,
    ]);

    function DeviceSettingsProvider() {
        return {
            $get: [
                'DeviceSettingsRepository',
                DeviceSettingsFactory,
            ],
        };
    }

    function DeviceSettingsFactory(DeviceSettingsRepository) {
        return DeviceSettingsRepository;
    }
})(angular);
